import {
  Row,
  Col,
} from 'react-bootstrap'
import { Link } from 'react-router-dom'

const Terms = ({ colProps, includeTitle }) => (
  <Row>
    <Col lg={colProps}>
      {includeTitle && <h2>Amenities Room Terms</h2>}
      <h3>Rental Terms</h3>
      <p>
        <ol>
          <li>Rentals are available only to residents who live at Imperial. Owners who have tenants may not rent the room themselves; however, the tenants may rent the Amenities Room.</li>
          <li>Amenities Room bookings are on a first come, first served basis up to 365 days in advance of the date requested.</li>
          <li>Booking requests received later than five (5) business days prior to the event date may not be accepted.</li>
          <li>Bookings are limited to a maximum of four (4) calendar dates per year, per strata owner, and a maximum of two (2) times per month unless otherwise approved by the Imperial strata council.</li>
          <li>The Strata council may designate days where the Amenities Room is open for common use by all residents and is not available for booking.</li>
          <li>The rental is for the exclusive use of the main floor. You may use the lower floor, too, but it will be open to all residents.</li>
        </ol>
      </p>

      <h3>Payment Terms</h3>
      <p>
        <ol>
          <li>The rental fee is $50 per booking. You must have a Pre-Authorized Debit (PAD) arrangement set up with Davin Management to pay this fee, and your rental will not be confirmed until that has been completed.</li>
          <li>If the agreed-upon clean-up procedures do not happen or there is any damage, or other care needed resulting from your rental of the space, the renting strata unit will be charged the cost to restore things to the previous state using the established PAD.</li>
          <li>The rental fee will be collected at the time of booking.</li>
          <li>Once a rental has been confirmed and the rental fee collected, the funds cannot be reversed. If you need to cancel your booking, you may do so using the booking site, and what you have paid will be kept as a credit for future rentals.</li>
        </ol>
      </p>

      <h3>Usage Terms</h3>
      <p>
        <ol>
          <li>Access of the amenity building will be provided via a personalized code which will be provided by the Council prior to the event. </li>
          <li>Any deficiencies in the building must be communicated by the renter prior to the start time of the event.</li>
          <li>An adult must be present at all times.</li>
          <li>Use of the Amenities Room is restricted to 8:00am through 10:00pm from Sunday to Thursday and 8:00am through 11:00pm on weekends (Friday and Saturday nights).</li>
          <li>It is the responsibility of the applicant booking the Amenities Room to ensure all regulations under the BC Liquor Law including but not limited to Special Event Liquor Policy are adhered to.</li>
          <li>Regardless of a Special Event Liquor Permit being needed, the applicant must provide proof of having personal liability insurance (minimum $2 million dollars).</li>
          <li>The occupancy limit of 59 must not be exceeded due to fire code, health and safety including provincial orders, and insurance reasons.</li>
          <li>The strata resident who made the booking must be present throughout the event to supervise the use of the Amenities Room.</li>
          <li>It is the Resident’s responsibility to ensure that his or her guests observe all By-laws and Terms. </li>
          <li>The Amenities Room is a No Smoking room. Smoking is not permitted in the Amenities Room, balcony, or the adjacent common grounds.</li>
          <li>No open-flame cooking is permitted indoors or outdoors at any time. This includes the balcony as well as any areas surrounding the amenity building. (Barbecues are permitted outside on the lower level only.)</li>
          <li>Guests shall utilize street parking or designated visitor parking spaces only.</li>
          <li>No pets are allowed in the Amenities Room with the exception of guide/service dogs.</li>
          <li>Do not place food or beverages on the pool table.</li>
          <li>The pool table is not to be moved under any circumstances.</li>
          <li>No tape, tacks, or adhesives to be used on any surface in the amenity room.</li>
        </ol>
      </p>

      <h3>Post-Usage Terms</h3>
      <p>
        <ol>
          <li>The resident renting the Amenities Room must supply all cleaning materials such as paper towels, garbage/recycling bags, dishes and dish soap.</li>
          <li>The Amenities Room must be left clean: kitchen, floors, and bathrooms cleaned.</li>
          <li>All refuse/debris/rubbish and any other items brought in must be removed from the amenity room immediately following the event.</li>
          <li>Any cleaning that is necessary subsequent to your rental will be deducted from your rental deposit at a rate of $60 per hour. Please refer to the <Link to="/clean-up">cleaning check-list</Link> and posted in the Amenities Room.</li>
          <li>The Amenities building must be left with all windows closed and latched, and all doors locked. Failure to do so may result in losing the ability to rent the facility.</li>
        </ol>
      </p>
    </Col>
  </Row>
)

Terms.defaultProps = {
  colProps: { span: 8, offset: 2 },
  includeTitle: true,
}

export default Terms
